import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { useForm } from "react-hook-form";

import APAccordion from "../../../components/APAccordion";
import APTextField from "../../../components/form/APTextField";
import { VehicleStandardEquipment } from "../../../types/Vehicles";

type Inputs = {
  search: string;
};

const VehicleStandardFeatures = ({
  features,
  filterable = false,
  forceOpen = false,
  forceClose = false,
  defaultExpanded = false,
}: {
  features: VehicleStandardEquipment[];
  filterable?: boolean;
  forceOpen?: boolean;
  forceClose?: boolean;
  defaultExpanded?: boolean;
}) => {
  const { control, watch } = useForm<Inputs>({ mode: "onTouched" });
  const search = watch("search");

  const filteredFeatures = useMemo(
    () =>
      filterable
        ? features.filter((feature) =>
            feature.description
              .toLowerCase()
              .includes(search?.toLowerCase() || "")
          )
        : features,
    [features, filterable, search]
  );

  return (
    <APAccordion
      title={"Standard Features"}
      forceOpen={forceOpen}
      forceClose={forceClose}
      defaultExpanded={defaultExpanded}
    >
      {filterable && (
        <Box my={2}>
          <APTextField<Inputs>
            name="search"
            label="Search"
            control={control}
            validations={{}}
            errors={{}}
            defaultValue={""}
          />
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {filteredFeatures.map((feature, i) => {
          return (
            <Box
              key={i}
              sx={{
                p: 1,
                backgroundColor: "neutralGray.light",
                borderRadius: "10px",
              }}
            >
              <Typography variant="titleMedium">
                {feature.description}
              </Typography>
            </Box>
          );
        })}
        {filteredFeatures.length === 0 && filterable && (
          <Typography variant="bodyMedium">
            No features match your search
          </Typography>
        )}
      </Box>
    </APAccordion>
  );
};

export default VehicleStandardFeatures;
